// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2nsni","footer":"ModalInfo_footer__13-Rg"};